import { RouterProvider } from 'react-router-dom';
import { router } from './routes'
import './styles/index.scss'
import ReactGA from "react-ga4";
import { useEffect } from 'react';

ReactGA.initialize(process.env.REACT_APP_GA as string);



function App() {
  useEffect(() => {
    if (!document.getElementById("gtm-script")) {
      const script = document.createElement("script");
      script.id = "gtm-script";
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-MQ7G2572');
      `;
      document.head.appendChild(script);
    }

    // GTM <noscript> 추가
    if (!document.getElementById("gtm-noscript")) {
      const noscript = document.createElement("noscript");
      noscript.id = "gtm-noscript";
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=MQ7G2572"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }, []);
  return <>
    <RouterProvider router={router} />
  </>;
}

export default App;
